import { selectOrganizationId, selectUserContext } from 'core/userContext';
import { SMART_INGEST_METRICS } from 'modules/billing/constants';
import { useHightouchBillingQueryContext } from 'modules/billing/contexts/HightouchBillingQueryContext';
import {
  createColumns,
  createHightouchMetricsByProjectId,
  createRows,
  queryByFn,
} from 'modules/billing/utils';
import { useSelector } from 'react-redux';
import { InputSearch } from 'ui/inputs';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { useSimpleIndexContext } from '../SimpleIndexPage/contexts';
import { createRowCell } from './TableCell';

const { productionSyncsCount, testSyncsCount } = SMART_INGEST_METRICS;

export const SMART_INGEST_USAGE_TEXT = {
  pageTitle: 'Smart Ingest Usage',
  searchInputId: 'smart-ingest-search',
};

/**
 * Search action for smart ingest projects
 * Extracted to here to access simple index context
 */
const PageActions = () => {
  const { setQuery, query } = useSimpleIndexContext();
  return (
    <InputSearch
      id={SMART_INGEST_USAGE_TEXT.searchInputId}
      data-test={SMART_INGEST_USAGE_TEXT.searchInputId}
      value={query}
      onChange={setQuery}
      placeholder="Search projects"
    />
  );
};

export const SmartIngestUsage = () => {
  const { projects: userContextProjects = [] } = useSelector(selectUserContext);
  const organizationId = useSelector(selectOrganizationId);
  const { isError, isHightouchEnabled, isLoading, hightouchOrg } =
    useHightouchBillingQueryContext();

  if (!isHightouchEnabled) {
    return null;
  }

  /**
   * Format rows and columns
   */
  const { projects = [] } = hightouchOrg || {};
  const hightouchMetricsByProjectId = createHightouchMetricsByProjectId(
    projects,
    userContextProjects,
  );
  const baseMetric = {
    organizationId,
    unit: 'Count',
  };
  const orgMetrics = [
    {
      ...baseMetric,
      metricName: productionSyncsCount,
      value: hightouchOrg?.organization?.productionSyncsCount || 0,
    },
    {
      ...baseMetric,
      metricName: testSyncsCount,
      value: hightouchOrg?.organization?.testSyncsCount || 0,
    },
  ];
  const columns = createColumns(hightouchMetricsByProjectId);
  const rows = createRows(orgMetrics, hightouchMetricsByProjectId);

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={{
        content: 'Usage and Billing',
        href: '/payments/info',
      }}
      pageTitle={SMART_INGEST_USAGE_TEXT.pageTitle}
      pageActions={<PageActions />}
      pluralResourceName="data syncs"
      isError={isError}
      isLoading={isLoading}
      queryByFn={queryByFn}
    />
  );
};
